<template>
  <div
    class="flex flex-col items-start w-full gap-2"
    :class="{
      'bg-block-2 p-5': primary,
    }"
  >
    <div class="flex items-center gap-2.5">
      <img
        :class="{
          'h-8 w-8': primary,
          'h-5 w-5': !primary,
        }"
        :src="img"
        alt=""
      />
      <h1
        class="text-md"
        :class="{
          'text-gray-3': primary,
          'text-white': !primary,
        }"
      >
        {{ title }}
      </h1>
    </div>
    <h1 class="text-white font-bold text-lg">{{ amount }}</h1>
  </div>
</template>

<script>
export default {
  name: "DashboardBlock",
  components: {},
  props: {
    img: {
      type: String,
      default: "/icons/buy-tax.png",
    },
    title: {
      type: String,
      default: "Buy Tax",
    },
    amount: {
      type: String,
      default: "$0.0243",
    },
    primary: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
